import AppService from "Global/AppService";
import * as CalAssaySummContants from './CalAssaySummConstants';


export const addDeviceToCalAssaySummReducerState = (instanceId) => {
	return {
		type: CalAssaySummContants.CAL_ASSAY_STATE_ADD,
		payload: instanceId
	}
};

export const removeDeviceToCalAssaySummReducerState = (instanceId) => {
	return {
		type: CalAssaySummContants.CAL_ASSAY_STATE_REMOVE,
		payload: instanceId
	}
};

export const getCalSummData = (url,payload,deviceId) => {
	
	return (dispatch) => {
		dispatch({ type: CalAssaySummContants.CAL_ASSAY_SUMMARY_DATA_FETCHING,payload:deviceId });

		function callback(success, err) {
			
			if (success?.result) {
				dispatch(getCalSummDataSuccess(success,deviceId));
			} else {
				dispatch(getCalSummDataFailure(deviceId));
			}
		}

		AppService.postData(payload, url, callback);
	}
}

export const getCalSummDataSuccess = (successResponse,deviceId) => {
	return { type: CalAssaySummContants.CAL_ASSAY_SUMMARY_DATA_FETCHED, payload:{newState: successResponse,deviceId:deviceId} };
}

export const getCalSummDataFailure = (deviceId) => {
	return { type: CalAssaySummContants.CAL_ASSAY_SUMMARY_DATA_FETCHING_FAILED,payload:deviceId };
}